<ion-header>
  <ion-toolbar mode="ios">
    <ion-back-button slot="start" text="" defaultHref="/home" color="dark" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-back-button>
    <ion-title class="ion-no-padding">
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="authServ.isLogged">
  <ng-container *ngIf="surveyForm">
    <form [formGroup]="surveyForm">
      <ion-grid>
        <ion-row class="form-wrapper">
          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked">{{'Name' | translate}} <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input formControlName="name"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked">{{'Surname' | translate}} <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input formControlName="surname"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked">{{'Room No' | translate}}
              </ion-label>
              <ion-input formControlName="room_no"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked">{{'Email' | translate}} <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input formControlName="email" type="email" email="true"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked">{{'Phone' | translate}}
              </ion-label>
              <ion-input formControlName="phone_no"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row class="button-wrapper">
          <ion-col size="6">
            <ion-button [disabled]="surveyForm.invalid" (click)="next()" expand="block">
              {{"Next" | translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ng-container>
</ion-content>


<ion-content *ngIf="!authServ.isLogged">
  <ion-row>
    <ion-col class="error" sizeLg="6" offsetLg="3" size="12">
      <ion-icon color="medium" name="log-in-outline" style="font-size: 128px;"></ion-icon><br>
      <ion-text color="medium" class="ion-margin">
        <h2> {{"Please login to answer the surveys." | translate}}</h2>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-content>